const FALLBACK_ALLOWED_ORIGINS = ['https://*.usemaia.com'];

const parseOrigins = (raw?: string): string[] =>
  (raw ?? '')
    .split(',')
    .map((origin) => origin.trim())
    .filter((origin) => origin.length > 0);

const configured = parseOrigins(import.meta.env.VITE_ALLOWED_ORIGINS);

export const ALLOWED_ORIGINS =
  configured.length > 0 ? configured : FALLBACK_ALLOWED_ORIGINS;

const toRegExp = (pattern: string): RegExp =>
  new RegExp(
    '^' +
      pattern.replace(/[.+?^${}()|[\]\\]/g, '\\$&').replace(/\*/g, '[^/]+') +
      '$',
  );

export const isOriginAllowed = (origin: string): boolean =>
  ALLOWED_ORIGINS.some(
    (allowed) =>
      allowed === origin ||
      (allowed.includes('*') && toRegExp(allowed).test(origin)),
  );
